import { CommonKeys } from "../../common/enums";
import { FormularGroup } from "./FormularGroup";

export interface FormularGroupInputs extends FormularGroup {
    Inputs: {
        [CommonKeys.Type]: string,
        [CommonKeys.Values]: FormularInput[]
    }
}

export interface FormularInput {
    ID?: string;
    Label?: string;
    Value?: string;
    Type?: EFormularInputType;
    Options?: FormularInputOptions;
}

export interface FormularInputOptions {
    MaxLen?: number;
    MinLen?: number;

    KeyboardType?: FormularInputKeyboardType;
}

export enum FormularInputKeyboardType {
    Default,
    Text,
    Url,
    Email,
    Phone,
    Numerical,
}

export type FormularInputType = "Entry" | "Editor" | "Checkbox" | "Date" | "Time" | "DateTime";

export enum EFormularInputType {
    /// Ein einzeiliges Eingabefeld
    Entry,
    /// Ein mehrzeiliges Textfeld
    Editor,
    /// Eine Box mit einem Haken zum aktivieren / deaktivieren
    Checkbox,
    /// Eine Auswahl für ein Datum
    Date,
    /// Eine Auswahl für eine Zeit
    Time,
    /// Eine Auswahl für ein Datum und eine Uhrzeit
    DateTime
}